var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_19258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6767 12.9296C15.887 11.278 16.4291 9.23025 16.1945 7.19607C15.9599 5.1619 14.9659 3.29131 13.4114 1.95855C11.8568 0.625789 9.85635 -0.0708582 7.81021 0.00798323C5.76407 0.0868247 3.82315 0.93534 2.37575 2.38377C0.928358 3.8322 0.0812323 5.77373 0.00385504 7.81993C-0.0735222 9.86613 0.624556 11.8661 1.95843 13.4197C3.2923 14.9733 5.1636 15.966 7.19794 16.1991C9.23228 16.4323 11.2796 15.8887 12.9304 14.6771H12.9292C12.9667 14.7271 13.0067 14.7746 13.0517 14.8209L17.8642 19.6334C18.0986 19.8679 18.4165 19.9998 18.7481 19.9999C19.0797 20 19.3977 19.8684 19.6323 19.634C19.8668 19.3996 19.9987 19.0817 19.9988 18.7501C19.9989 18.4185 19.8673 18.1004 19.6329 17.8659L14.8204 13.0534C14.7757 13.0081 14.7277 12.9664 14.6767 12.9284V12.9296ZM14.9992 8.12464C14.9992 9.02748 14.8213 9.92147 14.4758 10.7556C14.1303 11.5897 13.6239 12.3476 12.9855 12.986C12.3471 13.6244 11.5892 14.1308 10.7551 14.4763C9.921 14.8218 9.02701 14.9996 8.12417 14.9996C7.22133 14.9996 6.32733 14.8218 5.49322 14.4763C4.65911 14.1308 3.90121 13.6244 3.26281 12.986C2.62441 12.3476 2.118 11.5897 1.7725 10.7556C1.427 9.92147 1.24917 9.02748 1.24917 8.12464C1.24917 6.30127 1.9735 4.55259 3.26281 3.26328C4.55212 1.97397 6.30081 1.24964 8.12417 1.24964C9.94753 1.24964 11.6962 1.97397 12.9855 3.26328C14.2748 4.55259 14.9992 6.30127 14.9992 8.12464Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_19258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search-2.c53d6915136e32fc313e9a06347346af.svg";
export { ForwardRef as ReactComponent };